import React from 'react';
import { formatCurrency } from '../../../utils/assessmentResults/formatters';

/**
 * Recommendation card component
 */
export const RecommendationCard = ({ recommendation, index }) => {
  const costCategoryClass = recommendation.cost_category === 'low_cost'
    ? 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400'
    : recommendation.cost_category === 'medium_cost'
      ? 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400'
      : 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400';

  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-6 hover:shadow-md transition-shadow bg-white dark:bg-gray-900">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 text-xs px-2 py-1 rounded font-medium">
              ARC {recommendation.arc_code || '2.4231'}
            </span>
            <span className={`text-xs px-2 py-1 rounded font-medium ${costCategoryClass}`}>
              {recommendation.cost_category?.replace('_', '-') || 'Low-cost'}
            </span>
          </div>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-2">
            {recommendation.title || 'Eliminate unnecessary compressed air uses'}
          </h4>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
            {recommendation.description || 'Implement policies and controls to eliminate non-essential compressed air usage for cooling, sweeping, and other applications.'}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-100 dark:border-gray-700">
        <div>
          <div className="text-lg font-bold text-emerald-600 dark:text-emerald-400">
            {formatCurrency(recommendation.annual_savings || 15000)}
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Annual Savings</div>
        </div>
        <div>
          <div className="text-lg font-bold text-blue-600 dark:text-blue-400">
            {(recommendation.payback_years || 0.8).toFixed(1)} years
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Payback Period</div>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">Implementation details:</p>
        <p className="text-sm text-gray-700 dark:text-gray-300">
          {recommendation.implementation_preview || 'Survey compressed air points, install timers/controls, train operators on alternatives, establish usage policies...'}
        </p>
        <div className="mt-2 text-emerald-600 dark:text-emerald-400 text-sm font-medium">
          ✓ Full ARC implementation guide included
        </div>
      </div>
    </div>
  );
};

